import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";

const RELATED = [["/privacy-policy","Privacy Policy"],["/shipping-policy","Shipping Policy"],["/return-refund-policy","Return & Refund Policy"],["/cancellation-policy","Cancellation Policy"]];

export default function TermsConditions() {
  useSEO({
    title: "Terms & Conditions — PrintMyTees",
    description: "Read the PrintMyTees Terms & Conditions covering website use, orders, custom products, pricing, availability and customer responsibilities.",
  });

  return (
    <main className="container-pmt py-10 sm:py-16 max-w-4xl">
      <div className="overline text-[#E34F26]">PrintMyTees</div>
      <h1 className="mt-3 font-black text-3xl sm:text-4xl md:text-5xl uppercase">Terms & Conditions</h1>
      <p className="mt-3 text-sm text-stone-600">Last updated: October 2026</p>
      <div className="mt-8 sm:mt-10 space-y-8 sm:space-y-10 text-stone-700 leading-7">
        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">1. Use of the Website</h2>
          <p className="mt-2">By using the PrintMyTees website, customers agree to provide accurate information and use the website for lawful purposes.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">2. Orders</h2>
          <p className="mt-2">Customers are responsible for providing accurate contact, delivery, size, colour, and customization information when placing an order.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">3. Custom Products</h2>
          <p className="mt-2">Custom products are made according to the details selected or provided by the customer. Customers should carefully check customization details before completing payment.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">4. Pricing & Payment</h2>
          <p className="mt-2">Prices may vary depending on the selected product, customization, printing method, and quantity. Online payment is required for products offered for direct purchase.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">5. Product Availability</h2>
          <p className="mt-2">Product colours, sizes, materials, and availability may vary. PrintMyTees may contact the customer if a selected option is unavailable.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">6. Product Images & Variations</h2>
          <p className="mt-2">Product images are provided for reference. Actual colours, fabric appearance, printing results, and minor product details may vary from screen images.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">7. Customer Responsibilities</h2>
          <p className="mt-2">Customers should review order information before payment and keep their contact and delivery details accurate so the order can be processed correctly.</p>
        </section>
      </div>
      <div className="mt-10 sm:mt-12 border border-[#E6DFD5] bg-[#F3EDE2] p-5 sm:p-6">
        <div className="overline">Related Policies</div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {RELATED.map(([to,label]) => (
            <Link key={to} to={to} className="btn-outline-pmt text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">{label}</Link>
          ))}
        </div>
      </div>
      <Link to="/" className="inline-block mt-8 sm:mt-10 btn-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">Back to Home</Link>
    </main>
  );
}
